import { getHspDisplayName } from "shared/hspName";
import { getAdvisorSpecializationKeys } from "web_myplann/Advisor/Utils/getAdvisorSpecializationKeys";
import type { AgentDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { getAgentChatTitle } from "web_myplann/Shared/Utils/getAgentChatTitle";

export const mapAdvisorCardProps = (detail: AgentDetailResponseDTO) => ({
	id: detail.uid,
	name: detail.name ?? "",
	job: detail.role ?? undefined,
	specializations: getAdvisorSpecializationKeys(detail.specializations),
	hspName: getHspDisplayName(detail.hspName ?? "") || undefined,
	phone: detail.phone ?? undefined,
	email: detail.email,
	address: detail.address || undefined,
	linkedin: detail.linkedin || undefined,
	website: detail.website || undefined,
	description: detail.description || undefined,
	photo: detail.avatar ?? undefined,
	conversationId: detail.conversationId ?? undefined,
	chatTitle: getAgentChatTitle(detail),
	unreadCount: detail.unreadCount,
	showMainBadge: detail.isMain,
});
